import type {
  NotificationMessage,
  NotificationMessageSelected,
} from '../app/types/notification-message.type.ts';
import baseApi, { CacheTag } from './meeting-md-api-slice';

interface NotificationMessageQuery {
  limit?: number;
  unreadOnly?: boolean;
}

const notificationMessageApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchAllNotificationMessagesForCurrentUser: builder.query<
      NotificationMessageSelected[],
      NotificationMessageQuery
    >({
      query: params => ({
        url: '/NotificationMessage/CurrentUser',
        params,
      }),
      transformResponse: (response: NotificationMessage[]) => {
        return response.map(value => {
          return {
            ...value,
            selected: false,
          };
        });
      },
      providesTags: [CacheTag.NotificationMessages],
    }),
    markNotificationsRead: builder.mutation<void, string[]>({
      query: notificationMessageKeys => ({
        url: '/NotificationMessage/MarkRead',
        method: 'PUT',
        body: notificationMessageKeys,
      }),
      invalidatesTags: [CacheTag.NotificationMessages],
    }),
    markAllNotificationsRead: builder.mutation<void, void>({
      query: () => ({
        url: '/NotificationMessage/MarkAllRead',
        method: 'PUT',
      }),
      invalidatesTags: [CacheTag.NotificationMessages],
    }),
    markNotificationsUnread: builder.mutation<void, string[]>({
      query: notificationMessageKeys => ({
        url: '/NotificationMessage/MarkUnread',
        method: 'PUT',
        body: notificationMessageKeys,
      }),
      invalidatesTags: [CacheTag.NotificationMessages],
    }),
    deleteNotificationMessage: builder.mutation<void, string>({
      query: key => ({
        url: `/NotificationMessage/${key}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CacheTag.NotificationMessages],
    }),
  }),
});

export const {
  useFetchAllNotificationMessagesForCurrentUserQuery,
  useMarkAllNotificationsReadMutation,
  useMarkNotificationsReadMutation,
  useMarkNotificationsUnreadMutation,
  useDeleteNotificationMessageMutation,
} = notificationMessageApi;
